// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"a531588a","364":"1dd64a94","405":"42973771","539":"55082484","787":"9cf016e5","792":"71c49912","949":"8cf15a2a"}[chunkId] + ".chunk.js";
};